import { OptionEntity } from '@/types/OptionEntity';

export enum NotesTabsKeys {
  notes = 'notes',
  followUp = 'follow-ups',
  insights = 'insights',
}

export type TabOption = OptionEntity<NotesTabsKeys, string>;

export const TABS_ITEMS: TabOption[] = [
  {
    key: NotesTabsKeys.notes,
    value: 'Заметки',
  },
  {
    key: NotesTabsKeys.followUp,
    value: 'Follow-up',
  },
  {
    key: NotesTabsKeys.insights,
    value: 'Инсайты',
  },
];
